import React from "react";
import Dialog from "@material-ui/core/Dialog";
import {DialogActions, DialogTitle, DialogContent} from "../../Utils/Dialog/pharmacyDialog";
import {Link} from "react-router-dom";


const InvoicePrintDialog = ({openDialog, handleCloseDialog, message, cancel, print, text}) => {
    return (
        <Dialog open={openDialog}>
            <DialogTitle onClose={handleCloseDialog}>
                <div className="text-center">
                    View {message}
                </div>
            </DialogTitle>
            <DialogContent>
                <div className="text-center">
                    <p style={{fontSize:"14px"}}>Would you like to view the {text ? text : 'invoice'}?</p>
                </div>
            </DialogContent>
            <DialogActions>
                <div className="text-right">
                    <button onClick={print} type="button" className="btn pharmacy-info-btn mr-3">Yes</button>
                    <Link to={cancel}>
                        <button type="button" className="btn pharmacy-grey-btn ">No</button>
                    </Link>
                </div>
            </DialogActions>
        </Dialog>
    )

};
export default InvoicePrintDialog;
